import PropTypes from "prop-types";
import { styled } from "@mui/system";

const MyComponent = styled("div")({
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
  fontWeight: "bolder",
});

const ContentCell = ({ value }) => {
  return <MyComponent>{value}</MyComponent>;
};

ContentCell.propTypes = {
  value: PropTypes.string,
};

export default ContentCell;
